import { defineMessages } from 'react-intl';

export default defineMessages({
    selectNone: {
        id: 'policycommon.policy-details.directives.schedules.Select None',
        defaultMessage: 'The selected Item Type {itemTypeName} is not applicable for {itemName}. Please select \"None\"'
    },
    fillField: {
        id: 'policycommon.policy-details.directives.schedules.Please fill the field',
        defaultMessage: 'Please fill the field {fieldName}'
    },
    itemTypeNotApplicableForItem: {
        id: 'policycommon.policy-details.directives.schedules.The selected Item Type is not supported for Item',
        defaultMessage: 'The selected Item Type {itemTypeName} is not applicable for {itemName}. Please select {listOfItemTypes}'
    }
});

